import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_94: DocMigration = {
  maxSchemaVersion: "0.0.94",
  description: "Migrate window catalog to settings",
  apply(json: any) {
    if (json.windowCatalog) {
      const id = makeSettingsOverrideWindowCatalog(json);
      migrateWindowCatalogToSettingsOverride(json, json.windowCatalog, id);
    }
    delete json["windowCatalog"];

    for (const elevationId in json.elevations) {
      const elevation = json.elevations[elevationId];
      if (elevation.windowCatalog) {
        if (elevation.windowCatalog.length > 0) {
          const eId = makeSettingsOverrideWindowCatalog(elevation);
          migrateWindowCatalogToSettingsOverride(json, elevation.windowCatalog, eId);
        }
      }
      delete elevation["windowCatalog"];
    }
    return json;
  },
};

function makeSettingsOverrideWindowCatalog(json: any) {
  let id = uid();
  if (json.settingsOverride) {
    id = json.settingsOverride.windowCatalog ?? id;
    json.settingsOverride = {
      ...json.settingsOverride,
      windowCatalog: id,
    };
  } else {
    json.settingsOverride = { windowCatalog: id };
  }
  return id;
}

function migrateWindowCatalogToSettingsOverride(json: any, catalog, id) {
  const windowCatalog = json.settings[id] ?? {
    type: "WINDOW_CATALOG_SETTINGS",
  };

  const windowCatalogItems = {};
  for (const windowId in catalog) {
    const window = catalog[windowId];
    window.id = windowId;
    windowCatalogItems[windowId] = window;
  }

  windowCatalog["windowTypes"] = { ...windowCatalogItems };
  json.settings[id] = windowCatalog;

  return json;
}

export default migration_0_0_94;
